// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var QuestionMark = function QuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#questionmark-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.125 10a8.125 8.125 0 1 0-16.25 0 8.125 8.125 0 0 0 16.25 0M0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0m6.633-3.543A2.19 2.19 0 0 1 8.695 5h2.278a2.465 2.465 0 0 1 1.226 4.605l-1.261.723a.94.94 0 0 1-.938.922.935.935 0 0 1-.937-.937v-.528c0-.336.18-.644.472-.812l1.73-.993a.59.59 0 0 0-.292-1.101H8.695a.31.31 0 0 0-.293.207l-.015.047a.937.937 0 0 1-1.196.57.94.94 0 0 1-.57-1.195l.016-.047zM8.75 13.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "questionmark-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
